import React, { useState, useEffect } from "react";
// import ModalUnstyled from "@mui/core/ModalUnstyled";
import Dialog from "@mui/material/Dialog";
import { storage, db } from "../firebase";
import firebase from "firebase";
import ReactAudioPlayer from "react-audio-player";
import axios from "axios";
import Web3 from "web3";
import { contractAbi } from "./Contract";

export default function Create() {
  const [name, setName] = useState("");
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [coverImage, setCoverImage] = useState();
  const [coverImageUrl, setCoverImageUrl] = useState("");
  const [music, setMusic] = useState();
  const [description, setDescription] = useState("");
  const [tags, setTags] = useState("");
  const [tokenId, setTokenId] = useState("");
  const [txHash, setTxHash] = useState("");

  const createNft = async (assetHash, metaDataURI, contract_address) => {
    if (window.ethereum) {
      await window.ethereum.send("eth_requestAccounts");
      window.web3 = new Web3(window.ethereum);

      const accounts = await window.web3.eth.getAccounts();

      window.contract = await new window.web3.eth.Contract(
        contractAbi,
        "0xC27CA64B9E42b60cf92AA365457d3d9DB214566C"
      );

      let result;

      console.log(metaDataURI, "this is metaDatauri");

      const mynewNumber = await window.contract.methods
        .createCollectible(metaDataURI, 10)
        .send({ from: accounts[0] })
        .on("transactionHash", function (hash) {
          console.log(hash, "this is awardItem hash");
        })
        .on("receipt", function (receipt) {
          result = receipt;
          console.log(receipt, "this is award Item receipt");
        });

      console.log(mynewNumber, "this is my new number");

      return result;
    }
    alert("not enabled");
  };

  const onFormSubmit = async (e) => {
    e.preventDefault();
    setOpen(true);

    let creator;

    console.log(music, name, description);
    if (music === "" || name === "" || description === "") {
      alert("Fields cannot be empty");
      return;
    }

    if (window.ethereum) {
      await window.ethereum.send("eth_requestAccounts");
      window.web3 = new Web3(window.ethereum);
      var accounts = await window.web3.eth.getAccounts();
      creator = accounts[0];

      setLoading(true);

      const formData = new FormData();
      formData.append("myImage", music);

      const config = {
        headers: {
          "content-type": "multipart/form-data",
        },
      };
      axios
        .post("https://loud-final.herokuapp.com/upload", formData, config)
        .then((res) => {
          // console.log(res, "this the first response!");
          const myData = {
            name: name,
            creator: accounts[0],
            description: description,
            imagePath: res.data,
            cover: coverImageUrl,
            type: "music",
          };
          axios({
            method: "POST",
            url: "https://loud-final.herokuapp.com/create_meta_data",
            data: myData,
          })
            .then(async (res) => {
              const nft = await createNft(
                res.data.imageHash,
                res.data.metaDataURI,
                "0xC27CA64B9E42b60cf92AA365457d3d9DB214566C"
              );

              console.log(nft, "this is the nft");

              setTokenId(nft.events.Transfer.returnValues.tokenId);
              setTxHash(nft.transactionHash);
              let myNftImage = `https://ipfs.io/ipfs/${res.data.imageHash}`;

              axios({
                method: "POST",
                url: "https://loud-final.herokuapp.com/add_token_info",
                data: {
                  owner: nft.from,
                  tokenId: nft.events.Transfer.returnValues.tokenId,
                  txHash: nft.transactionHash,
                  onSale: true,
                  creator: creator,
                  name: name,
                  initialPrice: "",
                  ownerImage: "",
                  creatorImage: "",
                  royalty: "10",

                  quantity: "1",
                  category: "Art",
                  music: myNftImage,
                  coverImage: coverImageUrl,

                  description: description,
                  transfer: false,
                },
              })
                .then((res) => {
                  console.log("inisde here!!");
                  if (res.data === "success") {
                    setLoading(false);
                  }
                })
                .catch((e) => {
                  alert("some error occurred!!");
                });

              // alert(
              //   `successsfully created! TokenId:${nft.events.Transfer.returnValues.tokenId}, TxHash:${nft.transactionHash}`
              // );

              // setOpen();
            })
            .catch((e) => {
              console.log(e);
            });
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const uploadImage = (val) => {
    setOpen(true);
    setLoading(true);
    setCoverImage(val);
    const uploadTask = storage.ref(`images/${val.name}`).put(val);

    uploadTask.on(
      "state_changed",
      (snapshot) => {
        // progress function
        const progress = Math.round(
          (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        );
        // setProgress(progress);
      },
      (error) => {
        // Error function
        console.log(error);
        alert(error.message);
      },
      () => {
        // complete function ...
        storage
          .ref("images")
          .child(val.name)
          .getDownloadURL()
          .then((url) => {
            console.log(url, "this is uploaded url");
            setCoverImageUrl(url);
            // Post image URL inside db
            // db.collection("posts").add({
            //   timestamp: firebase.firestore.FieldValue.serverTimestamp(),
            //   caption: caption,
            //   imageUrl: url,
            //   username: username,
            //   imagename: image.name,
            // });

            // Reset everything once upload process is completed
            setLoading(false);
            setOpen(false);
          });
      }
    );
  };
  return (
    <div className="create">
      <Dialog
        // selectedValue={selectedValue}
        open={open}
        onClose={() => setOpen(false)}
      >
        <div style={{ width: "300px", height: "300px" }}>
          {loading ? (
            <>
              <center style={{ marginTop: "100px" }}>Loading..</center>
            </>
          ) : (
            <div>
              <center>
                <h1>Nft Minted</h1>
                <a href={`/nftdetails/${tokenId}`}>Click here</a> to view NFT
              </center>
            </div>
          )}
        </div>
      </Dialog>
      <div className="create-header">NFT CREATION</div>
      <div>
        <input
          placeholder="Title"
          className="nft-title"
          style={{ marginBottom: "20px" }}
          onChange={(e) => setName(e.target.value)}
        />
      </div>
      <div>
        <textarea
          placeholder="description"
          className="nft-description"
          onChange={(e) => setDescription(e.target.value)}
        />
      </div>
      <div>
        <input
          placeholder="Tags"
          className="nft-tags"
          style={{ marginTop: "20px" }}
        />
      </div>
      <div className="upload-container">
        <div className="cover-image-wrapper">
          <div className="nft-cover">
            {/* <div style={{ fontSize: "140px" }}>+</div> */}
            <div>
              <input
                style={{ width: "88px" }}
                type="file"
                onChange={(e) => uploadImage(e.target.files[0])}
              />
            </div>
            <div style={{ marginTop: "20px" }}>Add Cover Image</div>
          </div>
          <div>
            <img
              src={
                coverImageUrl === ""
                  ? "https://kandys.lk/img/categories/3.jpg"
                  : coverImageUrl
              }
              alt="no"
              style={{ Width: "300px", height: "300px" }}
            />
          </div>
        </div>
        <div className="nft-music-upload-wrapper">
          <div className="nft-music-upload">
            <input type="file" onChange={(e) => setMusic(e.target.files[0])} />
            <div style={{ marginTop: "20px" }}>Upload MP3</div>
          </div>
          {/* <div>
            <ReactAudioPlayer src={music ? music : ""} autoPlay controls />
          </div> */}
        </div>
      </div>
      <div
        style={{
          marginTop: "20px",
          textAlign: "center",
          width: "80%",
          background: "orange",
          padding: "10px",
          marginBottom: "40px",
          cursor: "pointer",
        }}
        onClick={(e) => onFormSubmit(e)}
      >
        Create NFT
      </div>
    </div>
  );
}
